import React from 'react';

const SvgIconJumpDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 8 6" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 0l4 6H0z" fillRule="evenodd" />
  </svg>
);

export default SvgIconJumpDown;
